<template>
  <div v-show="show_tan" class="pre_tan">
    <span class="pre_tan_bg" @click="closeshow"></span>
    <div class="pre_tan_conten">
      <span class="pre_tan_close">
        <img src="../../assets/image/shan1.png" @click="closeshow" />
      </span>
      <div class="pre_upload">
        <div class="pre_leve_one">
          <h3>{{title}}</h3>
        </div>
        <div class="pre_leve_two">
          <!-- 这里放相关内容-->
          <ul>
            <li v-for="(item,index) in parm" :key="index">
              <span class="pre_left">{{item.name}}:</span><span class="pre_right">{{item.val}}</span>
            </li>
          </ul>





        </div>

        <!-- 弹出向导层 end-->
      </div>
    </div>

  </div>
</template>

<script>
  /*
名称：通用少字段操作,不支持下拉菜单
日期：2020-11-29
作者：hj
目标：
使用 props 控制，会互相干扰
所以用  ref
基本操作+编辑区+表格
*/


  export default {
    name: "pre_tan_detail",
    data() {
      return {
        element_loading: false,
        show_tan: false,
        title: '',
        parm: [], //备份点击项目

      };
    },
    methods: {
      load_data: function(d) {
        this.open_show();
        let r = JSON.parse(d);
        // console.log(r);
        this.title = r.title;
        let a = [],
          b = [];
        a = r.parm_th;
        b = r.parm;
        let l1 = 0,
          l2 = 0;
        l1 = a.length;
        // l2 = b.length;
        // if (l1 > l2) {
        //   l1 = l2;
        // }

        // console.log(this.parm);
        // console.log(this.parm_th);
        this.parm = [];
        for (let i = 0; i < l1; i++) {
          let o = {};
          o.name = a[i].name;
          o.val = b[i].val;
          this.parm.push(o);
        }

      },
      open_show: function() {
        this.show_tan = true;
        var Hg = $(document).height();
        // 设置背景高度
        $(".pre_tan_bg").height(Hg);
        // 设置展示动画 第一次有慢入动作,第二次没有:原因是当前页面被缓存，除非重开
        $(".pre_tan_bg").fadeIn("3000");
        $(".pre_tan_conten").fadeIn("3000");
      },
      closeshow: function() {
        this.show_tan = false;
        $(".pre_tan_bg").fadeOut("3000");
        $(".pre_tan_conten").fadeOut("3000");
      }

    }
  };
</script>


<style scoped>
  h3 {
    text-align: center;
  }

  ul {
    list-style: none;
  }

  ul>li{
    /* margin-top: 1px; */
    border: 1px solid #808080;
  }

  li>span {
    display: inline-block;

    color: #000000;
    font-size: 16px;
  }

  li>.pre_left {
    font-weight: bolder;
    text-align: right;
    padding: 2px 2px 2px 2px;
    min-width: 128px;
  }

  li>.pre_right {
    text-align: left;
    padding: 2px 2px 2px 2px;
  }
</style>
